import React from 'react';

// Don't add spacebar (32)
const keys = {
  33: 1, // Pageup
  34: 1, // Pagedown
  35: 1, // End
  36: 1, // Home
  37: 1, // Left
  38: 1, // Up
  39: 1, // Right
  40: 1, // Down
};
// Cannot simulate keydown events, please change if can be improved
function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  e.returnValue = false;
}

// Cannot simulate keydown events, please change if can be improved
function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);

    return false;
  }
}

function disableScroll() {
  if (window.addEventListener) {
    // Older FF
    window.addEventListener('DOMMouseScroll', preventDefault, false);
  }
  window.onwheel = preventDefault; // Modern standard
  window.onmousewheel = preventDefault;
  document.onmousewheel = preventDefault; // Older browsers, IE
  window.ontouchmove = preventDefault; // Mobile
  document.onkeydown = preventDefaultForScrollKeys;

  document.body.style.overflowY = 'hidden';
}

function enableScroll() {
  if (window.removeEventListener) {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
  }
  window.onmousewheel = null;
  document.onmousewheel = null;
  window.onwheel = null;
  window.ontouchmove = null;
  document.onkeydown = null;

  document.body.removeAttribute('style');
}

/**
 * A higher-order component that disables/enables screen scrolling when
 * the wrapped component is mounted/unmounted.
 *
 * The approach used is to disable all input that can lead to scrolling. Other CSS-only
 * solutions exist but this solution is purer without other potential side effects.
 */
export default function disableScreenScrolling(WrappedComponent) {
  class DisableScreenScrolling extends React.Component {
    componentDidMount() {
      disableScroll();
    }

    componentWillUnmount() {
      enableScroll();
    }

    render() {
      // Pass through all props
      return <WrappedComponent {...this.props} />;
    }
  }

  return DisableScreenScrolling;
}
